import React from 'react';

function Hero() {
    return (
        <section id="hero">
            <div className="hero-container">
                <a href="#hero"><img src="img/neeq-logo.png" width="200" alt="" title="" /></a>
                <h2>Núcleo de Estudantes de Engenharia Química da <br />Faculdade de Engenharia da Universidade do Porto</h2>
            </div>
        </section >
    );
}

export default Hero;